import { ItemTypeConsts } from 'client/util/Constants';
import { trialPropsData } from 'client/util/Constants/FeatureTrialConstants';
import GettingStartedPanelSettings from 'client/components/GettingStartedPanel/GettingStartedPanelSettings';

const ConfigurationAsidePanel = () => import('client/policies/ConfigurationAsidePanel.vue');
const PoliciesChooserAsidePanel = () => import('client/policies/PoliciesChooserAsidePanel.vue');
const PoliciesTabsMainPanel = () => import('client/policies/PoliciesTabsMainPanel.vue');

const configurationsProps = {
  asidePanel: {
    isExpanded: true,
    itemType: ItemTypeConsts.configuration,
  },
  mainPanel: {
    gettingStartedPanelItemType: ItemTypeConsts.configuration,
    isAsideOpen: false,
    itemType: ItemTypeConsts.configuration,
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const modalProps = trialPropsData.osPatchManagement;

const metaData = {
  title: 'Policy Management',
  tooltipProps: {
    linkHref: GettingStartedPanelSettings[ItemTypeConsts.configuration].learnMoreUrl,
    pText: GettingStartedPanelSettings[ItemTypeConsts.configuration].tooltipText,
  },
};

const osPatchMeta = {
  ...metaData,
  modalProps,
  feature: ItemTypeConsts.osPatchManagement,
};

export default [
  {
    path: '/configurations/choose/:os?',
    name: 'newPolicyOs',
    meta: metaData,
    components: {
      mainPanel: PoliciesTabsMainPanel,
      asidePanel: PoliciesChooserAsidePanel,
    },
    props: {
      mainPanel: configurationsProps.mainPanel,
      asidePanel: route => ({
        ...configurationsProps.asidePanel,
        os: route.params.os,
      }),
    },
  },
  {
    path: '/configurations',
    name: 'configurationsMainPanelAll',
    meta: metaData,
    components: {
      mainPanel: PoliciesTabsMainPanel,
    },
    props: {
      mainPanel: configurationsProps.mainPanel,
    },
  },
  {
    path: '/configurations/patch',
    name: 'configurationsMainPanelPatchMgmt',
    meta: osPatchMeta,
    components: {
      mainPanel: PoliciesTabsMainPanel,
    },
    props: {
      mainPanel: {
        ...configurationsProps.mainPanel,
        initialTabIndex: 1,
      },
    },
  },
  {
    name: 'patchDetails',
    path: '/configurations/patch/:id/details/',
    meta: osPatchMeta,
    components: {
      mainPanel: PoliciesTabsMainPanel,
      asidePanel: ConfigurationAsidePanel,
    },
    props: {
      mainPanel: configurationsProps.mainPanel,
      asidePanel: route => ({
        ...configurationsProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    name: 'osPatchDetails',
    path: '/configurations/patch/os/:id/details/',
    meta: osPatchMeta,
    components: {
      mainPanel: PoliciesTabsMainPanel,
      asidePanel: ConfigurationAsidePanel,
    },
    props: {
      mainPanel: configurationsProps.mainPanel,
      asidePanel: route => ({
        ...configurationsProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/configurations/patch/os',
    name: 'configurationsMainPanelOsPatchMgmt',
    meta: osPatchMeta,
    components: {
      mainPanel: PoliciesTabsMainPanel,
    },
    props: {
      mainPanel: {
        initialTabIndex: 1,
      },
    },
  },
  {
    path: '/configurations/:id/details/:initialTab?/:policiesTab?/:patchMgmtTab?',
    name: 'configurationsDetailsInitialTab',
    meta: metaData,
    components: {
      mainPanel: PoliciesTabsMainPanel,
      asidePanel: ConfigurationAsidePanel,
    },
    props: {
      mainPanel: route => ({
        ...configurationsProps.mainPanel,
        initialTabIndex: Number(route.params.policiesTab) || 0,
        patchManagementTabIndex: Number(route.params.patchMgmtTab) || 0,
      }),
      asidePanel: route => ({
        ...configurationsProps.asidePanel,
        itemId: route.params.id,
        navigateToTab: { tabLabel: route.params.initialTab || 0 },
      }),
    },
  },
  {
    path: '/configurations/configure/:os/:templateId',
    name: 'newPolicyConfigure',
    meta: metaData,
    components: {
      mainPanel: PoliciesTabsMainPanel,
      asidePanel: ConfigurationAsidePanel,
    },
    props: {
      mainPanel: configurationsProps.mainPanel,
      asidePanel: route => ({
        ...configurationsProps.asidePanel,
        templateId: route.params.templateId,
        os: route.params.os,
      }),
    },
  },
  {
    path: '/configurations/patch/browser',
    name: 'configurationsMainPanelBrowserPatchMgmt',
    meta: osPatchMeta,
    components: {
      mainPanel: PoliciesTabsMainPanel,
    },
    props: {
      mainPanel: {
        initialTabIndex: 1,
        patchManagementTabIndex: 1,
      },
    },
  },
  {
    name: 'browserPatchDetails',
    path: '/configurations/patch/browser/:id/details/',
    meta: osPatchMeta,
    components: {
      mainPanel: PoliciesTabsMainPanel,
      asidePanel: ConfigurationAsidePanel,
    },
    props: {
      mainPanel: {
        ...configurationsProps.mainPanel,
        initialTabIndex: 1,
        patchManagementTabIndex: 1,
      },
      asidePanel: route => ({
        ...configurationsProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
];
